var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckmarkPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4545 7.99998C13.4545 11.0124 11.0124 13.4545 7.99992 13.4545C4.98746 13.4545 2.54537 11.0124 2.54537 7.99998C2.54537 4.98752 4.98746 2.54543 7.99992 2.54543C11.0124 2.54543 13.4545 4.98752 13.4545 7.99998ZM14.6666 7.99998C14.6666 11.6819 11.6818 14.6666 7.99992 14.6666C4.31802 14.6666 1.33325 11.6819 1.33325 7.99998C1.33325 4.31808 4.31802 1.33331 7.99992 1.33331C11.6818 1.33331 14.6666 4.31808 14.6666 7.99998ZM11.4986 6.56653C11.7112 6.30802 11.674 5.92609 11.4155 5.71347C11.157 5.50084 10.7751 5.53804 10.5624 5.79655L7.69475 9.28306C7.57439 9.42938 7.35644 9.4461 7.21518 9.31985L5.37378 7.6741C5.12421 7.45105 4.74108 7.47254 4.51802 7.72211C4.29497 7.97168 4.31647 8.35481 4.56604 8.57787L7.09012 10.8338C7.37265 11.0863 7.80855 11.0528 8.04926 10.7602L11.4986 6.56653Z",
    fill: "#614EFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckmarkPurple);
export default __webpack_public_path__ + "static/media/icon_checkmark_purple.7f7c3a0a1e8fac56c20261f0daa6da8e.svg";
export { ForwardRef as ReactComponent };